import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.page.html',
  styleUrls: ['./contact-us.page.scss'],
})
export class ContactUsPage implements OnInit {
  public contactForm: UntypedFormGroup;

  constructor(
    public formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required]],
      subject: [null, [Validators.required]],
      message: [null, [Validators.required]]
    })
  }

  onSubmit() {
    console.log('FIRED');
  }

}
